/**
 * LYT Team Redux Actions
 * Actions for managing LYT internal team members data
 */

// ── Members Action Types ──
export const LYT_TEAM_MEMBERS_REQUEST = 'lytTeam/MEMBERS_REQUEST';
export const LYT_TEAM_MEMBERS_SUCCESS = 'lytTeam/MEMBERS_SUCCESS';
export const LYT_TEAM_MEMBERS_ERROR = 'lytTeam/MEMBERS_ERROR';
export const LYT_TEAM_MEMBERS_RESET = 'lytTeam/MEMBERS_RESET';
export const LYT_TEAM_MEMBERS_SET_PARAMS = 'lytTeam/MEMBERS_SET_PARAMS';

// Action Creators

/**
 * Request action for fetching LYT team members
 * @returns {Object} Action object
 */
export const getLytTeamMembersRequest = () => ({
    type: LYT_TEAM_MEMBERS_REQUEST,
});

/**
 * Success action for fetching LYT team members
 * @param {Object} payload
 * @param {Array} payload.data - Array of user/invite objects (mixed via is_prospect flag)
 * @param {Object} payload.pagination - { offset, limit, count }
 * @returns {Object} Action object
 */
export const getLytTeamMembersSuccess = ({ data, pagination }) => ({
    type: LYT_TEAM_MEMBERS_SUCCESS,
    payload: { data, pagination },
});

/**
 * Error action for fetching LYT team members
 * @param {string} error - Error message
 * @returns {Object} Action object
 */
export const getLytTeamMembersError = (error) => ({
    type: LYT_TEAM_MEMBERS_ERROR,
    payload: error,
});

/**
 * Reset action for clearing LYT team members state
 * @returns {Object} Action object
 */
export const resetLytTeamMembers = () => ({
    type: LYT_TEAM_MEMBERS_RESET,
});

/**
 * Update the stored query params (search, sort, filter, page) without triggering a fetch
 * @param {Object} params - Updated query params
 * @returns {Object} Action object
 */
export const setLytTeamMembersParams = (params) => ({
    type: LYT_TEAM_MEMBERS_SET_PARAMS,
    payload: params,
});
